export default {
  dba_report_title: '长文本总结',
  dba_report_prompt: 'Prompt',
  dba_report_prompt2: '合并Prompt',
  dba_report_attachments: '附件',
  dba_report_prompt_placeholder: '使用流畅的中文进行会议纪要总结，包括参与人、要点、下一步动作等',
  dba_report_upload_button_select: '选择文件',
  dba_report_upload_message: '请上传.txt文件，上传大小在5MB以内',
  dba_report_submit: '提交',
  dba_report_result_title: '结果',
  dba_report_prompt_error_none: 'Prompt不允许为空',
  dba_report_file_error_none: '请选择文件',
  dba_report_copy_text: '复制文本',
};
